<div class="container-fluid">
    <div class="row">
      <div *ngIf="caseDetails && caseDetails.settings.allowAddEditRelated && AddRelatedCaseShow==false" class="col-12" style="display:flex;justify-content: flex-start;">
        <button class="btn btn-primary m-3" (click)="openCreateModal()">
            <i class="fa fa-plus-circle"></i>
            <span> {{'AddRelatedCase' | translate}} </span>
        </button>
      </div>
      <div class="col-sm-12" *ngIf="AddRelatedCaseShow==false">
        <div class="card">
          <table class="table table-striped mt-3">
            <thead class="thead-dark">
              <tr>
                <th>{{ "numCase" | translate }}</th>
                <th>{{ "caseTypeName" | translate }}</th>
                <th>{{ "CaseCreator" | translate }}</th>
                <th>{{ "createDate" | translate }}</th>
                  <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let relatedCase of relatedCasesArr">
                <td>{{ relatedCase.caseNumber }}</td>
                <td>{{ relatedCase.caseTypeName }}</td>
                <td>{{ relatedCase.creatorName }}</td>
                <td>{{ relatedCase.createdOn | toDateTime }}</td>
                <td>

                    
                    <a *ngIf="relatedCase.caseTypeId==4 && relatedCase.categoryId !== 2" (click)="internalRservice.printReport(relatedCase.caseId);">{{ "InternalReport" | translate }}</a> <br /> 
                    <a *ngIf="relatedCase.caseTypeId==4 && relatedCase.categoryId !== 1" (click)="criminalRservice.printReport(relatedCase.caseId);">{{ "CriminalReport" | translate }}</a> 
                       

                  
          </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</div>

<!-- add -->
 <div class="card p-3" *ngIf="AddRelatedCaseShow==true">
 
  <div   style="justify-content: space-between">
    <h4   id="modal-basic-title">
      {{ "AddRelatedCase" | translate }}
    </h4>
     
  </div>
  <div  >
      <div class="custom-form">
          <div class="col-12 offset-1">
            <div class="card p-3">
              <div class="form-group row mt-3">
                <div class="col-lg-12">
                  <div class="divformlabel">
                    <label>{{ "caseTypeName" | translate }}</label>
                    <span
                      *ngIf="CaseType.invalid"
                      class="alert"
                      style="
                        color: red;
                        white-space: nowrap;
                        line-height: 0;
                        padding: 0;
                        margin-top: 8px;
                      "
                    >
                      <div *ngIf="CaseType.errors?.required">*</div>
                    </span>
                  </div>
                  <ng-select
                    id="CaseType"
                    required
                    #CaseType="ngModel"
                    class="form-control-select"
                    [items]="caseTypesArr"
                    bindLabel="text"
                    bindValue="id"
                    [(ngModel)]="caseTypeId"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="{{ 'caseTypeName' | translate }}"
                  >
                  </ng-select>
                </div>
                <div class="col-lg-12 mt-3">
                  <div style="display: flex; flex-wrap: nowrap; height: 30px">
                    <label>{{ "Description" | translate }}</label>
                    <span
                      *ngIf="Description.invalid"
                      class="alert"
                      style="
                        color: red;
                        white-space: nowrap;
                        line-height: 0;
                        padding: 0;
                        margin-top: 8px;
                      "
                    >
                      <div *ngIf="Description.errors?.required">*</div>
                    </span>
                  </div>
                  <textarea
                    id="Description"
                    required
                    #Description="ngModel"
                    class="form-control"
                    rows="2"
                    [(ngModel)]="description"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="{{ 'Description' | translate }}"
                  >
                  </textarea>
                </div>
              </div>
            </div>
          </div>
      </div>
  </div>
  <div class="row m-2 col-12 justify-content-center">

    <button
      [disabled]="Description.invalid || CaseType.invalid"
      type="button"
      class="btn btn-primary col-lg-2 m-1"
      (click)="AddRelatedCase(reltedCaseAddedeModal)"
    >
    {{ "Save and Back" | translate }}

    </button>
    <button type="button" class="btn btn-danger col-lg-2 m-1" (click)="AddRelatedCaseShow=false;">
      {{ "BackLists" | translate }}
    </button>
  </div>
 

</div>
<ng-template #reltedCaseAddedeModal let-modal>
    <div class="modal-header" style="justify-content: end">
      <i
        style="font-size: 20px"
        class="fa fa-close"
        (click)="modal.dismiss('Cross click')"
      ></i>
    </div>
    <div class="modal-body">
        <div class="custom-form">
            <div class="col-12 offset-1">
              <div class="card p-3">
                <div class="form-group row mt-3">
                    <h4 style="text-align:center">{{message}}</h4>
                </div>
              </div>
            </div>
        </div>
    </div>
    <div
      class="modal-footer row"
      style="justify-content: end; padding: 1rem 2rem"
    >
      <button
        type="button"
        class="btn btn-dark col-lg-3"
        (click)="modal.dismiss('Cross click')"
      >
        {{ "Close" | translate }}
      </button>
    </div>
</ng-template>

